/*
 * @Author: lidan
 * @Date: 2021-05-31 10:12:59
 * @LastEditTime: 2021-06-04 17:05:20
 * @LastEditors: lidan
 * @Description: 出厂、入厂，卸货检查弹窗
 * @FilePath: \e6-module-order-waybill-process\src\e6-module-order-waybill-process\api\checkUpDialog.js
 */
import http from "e6-base-core/axios/config";
import { e6ModuleOrderWaybillProcessApi } from "@/config/api";
const { host, E6_MS_TMS_BUSI_WEB } = e6ModuleOrderWaybillProcessApi;

/* ************** 出厂、入厂，卸货检查弹窗 **************** */
//保存
export function saveCheck(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybillAction/check`,
    method: "post",
    data
  });
}
//校验是否需要检查
export function checkFlag(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybill/check/flag`,
    method: "post",
    data
  });
}
//查询待检查点
export function checkNode(params) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybill/check/node`,
    method: "get",
    params
  });
}
//查询检查点的问题
export function checkQuestion(params) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybill/check/question`,
    method: "get",
    params
  });
}
